module.exports = __webpack_public_path__ + "pc/img/rec_23.31b5e798.svg";